import { getUrl } from 'aws-amplify/storage';
import { v4 as uuidv4 } from 'uuid';
import { s3UploadFile } from './s3Service';
import { apiDelete, apiGet, apiPost, apiPut } from './api-service';
import { useState } from 'react';

let documentHistory = {
    recordId: '',
    documentId: '',
    name: ''
};

export function setDocumentHistoryDetails(details: any) {
    documentHistory = details;
}

export function getDocumentHistoryDetails() {
    return documentHistory;
}

export async function getRecordDocuments(record_id: string) {
    try {
        const response = await apiGet('core', `document`, {
            queryParams: {
                record_id
            }
        });

        return response.content;
    } catch (e) {
        return [];
    }
}

export async function addDocument(documentBody: any) {
    try {

        const response = await apiPost('core', `document`, documentBody);

        return response;
    } catch (e) { }
}

export async function updateDocument(id: string, documentBody: any) {
    try {
        const response = await apiPut('core', `document/${id}`, documentBody);

        return response;
    } catch (e) { }
}

export async function addMetaDocument(document: string, documentBody: any, file?: any) {
    try {
        const id = uuidv4();
        documentBody.id = id;
        if (file) {
            const key = `document/${document}/meta/${id}`;
            await s3UploadFile(key, file);
            documentBody.s3_key = key;
        }

        const response = await apiPost('core', `meta`, documentBody);

        return response;
    } catch (e) { }
}

export async function updateMetaDocument(id: string, documentBody: any) {
    try {
        const response = await apiPut('core', `meta/${id}`, documentBody);
        return response;
    } catch (e) { }
}

export async function removeMetaDocument(id: any) {
    try {
        return await apiDelete('core', `meta/${id}`);
    } catch (e) { }
}


export async function removeDocument(id: any) {
    try {
        return await apiDelete('core', `document/${id}`);
    } catch (e) { }
}

export async function downloadFile(name: string, path: string) {
    try {
        const file = await getUrl({
            key: path,
            options: {
                accessLevel: 'guest'
            }
        });
        window.open(file.url, '_blank');
        // await fetch(file.url)
        //     .then((response) => response.blob())
        //     .then((blob) => {
        //         // Create blob link to download
        //         const url = window.URL.createObjectURL(
        //             new Blob([blob]),
        //         );
        //         window.open(url,'_blank');
        //         // const link = document.createElement('a');
        //         // link.href = url;
        //         // link.setAttribute(
        //         //     'download',
        //         //     `${name}.pdf`,
        //         // );

        //         // // Append to html link element page
        //         // document.body.appendChild(link);

        //         // // Start download
        //         // link.click();

        //         // // Clean up and remove the link
        //         // link.parentNode?.removeChild(link);
        //     });
        return true;
        // return await restOperation.response;
    } catch (e) {
        return false;
    }
}